// Toggle (switch) primitive — the design's 40×23 pill with a sliding knob.

interface Props {
  on: boolean;
  onToggle: () => void;
  label: string;
  disabled?: boolean;
}

export function Toggle({ on, onToggle, label, disabled = false }: Props) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      disabled={disabled}
      className={on ? 'bz-toggle bz-toggle-on' : 'bz-toggle'}
      onClick={onToggle}
    >
      <span className="bz-toggle-knob" />
    </button>
  );
}
